import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import SkeletonTable from "../../../components/table/SkeletonTable";
import columns from "../../../columns/reports/auditReport";
import { GetAuditReportApi } from "../../../api/request/report";
import { tableScrollTop } from "../../../utils/utils";

const AuditModal = ({ file, isOpen, setIsOpen }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getAuditReportData = async () => {
    setIsLoading(true);
    try {
      const { data } = await GetAuditReportApi({ file_id: file?.id });
      if (data?.status) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              taskName: item?.task?.name,
              message: <div className="text-wrap">{item?.message}</div>,
            };
          })
        );
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (file?.id) getAuditReportData();
  }, [file]);

  useEffect(() => {
    tableScrollTop();
  }, [isOpen]);

  return (
    <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} width={1300}>
      <div className="max-h-[600px] h-full overflow-auto">
        <div className="mb-5 text-center font-semibold text-xl"> 
          <p>Audit Report</p>
          <p className="capitalize">{`${file?.service_name_slug} (#${file?.file_number})`}</p>
        </div>
        <div className="overflow-auto max-h-[450px]">
          <SkeletonTable
            columns={columns}
            data={data}
            isLoading={isLoading}
            stickHeader={true}
          />
        </div>
      </div>
    </ModalComponent>
  );
};

export default AuditModal;
